<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@visibility="visibility"
			@edit="edit"
			@search="search">
		</fab>

		<search ref="search" :user="user" :isAuth="isAuth" @reload="reload"></search>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import fab from 'vue-fab'
	import Search from '@/components/search/layout/Search'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			fab,
			'search': Search,
		},
		created() {
			this.init()
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					tooltip: true,
					fabActions: null,
				}
			}
		},
		watch: {
			data() {
				this.loadActions()
			},
		},
		methods: {
			init() {
				this.loadActions()
			},
			loadActions() {
				if(this.type == 'show') {
					var actions = []
					if(this.data.delivery_note_status_id == 1) {
						actions.push({
							tooltip: 'Editar',
							name: 'edit',
							icon: 'mode_edit',
						})
					}
					actions.push({
						tooltip: 'Buscar',
						name: 'search',
						icon: 'search',
					})
				}
				if(this.type == 'edit') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}
				if(this.type == 'index') {
					var actions = [
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}

				this.fab.fabActions = actions
			},
			edit() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/deliverynotes/' + this.data.id + '/edit')
			},
			visibility() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/deliverynotes/' + this.data.id)
			},
			search() {
				this.$refs.search.open('deliverynotes')
			},
			reload() {
				this.$emit('reload')
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Fab.vue